export default __webpack_public_path__ + "static/modal-dont-dark-97a928fba6292dfaf86e4f735c3fd1db.png";